import { HttpClient, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { PRODUCTS_SERVICE_URL } from 'src/app/injection-tokens';
import { Observable } from 'rxjs';
import { ImportAreaReport, ImportAreaStatus } from './product-import-report-types';

@Injectable({
  providedIn: 'root',
})
export class ProductImportReportService {
  private readonly areasUrl: string;

  constructor(
    @Inject(PRODUCTS_SERVICE_URL) readonly baseServiceUrl: string,
    readonly http: HttpClient
  ) {
    this.areasUrl = baseServiceUrl + '/products/import/areas';
  }

  getAreaBoard(): Observable<ImportAreaStatus[]> {
    return this.http.get<ImportAreaStatus[]>(this.areasUrl);
  }

  getAreaReports(code: string, limit: number = 20): Observable<ImportAreaReport[]> {
    const params = new HttpParams().set('limit', limit);
    return this.http.get<ImportAreaReport[]>(`${this.areasUrl}/${encodeURIComponent(code)}/reports`, { params });
  }

  reorderAreas(orderedCodes: string[]): Observable<void> {
    // eslint-disable-next-line @typescript-eslint/no-invalid-void-type
    return this.http.put<void>(`${this.areasUrl}/order`, orderedCodes);
  }
}
